module.exports = __webpack_public_path__ + "img/nlc2.9eeb0b7d.svg";